// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"581":"cd1dfb85","717":"fd776f4e","829":"f3889772","913":"0148eab9"}[chunkId] + ".chunk.js";
};